// import { alertActions } from "./alert-actions";
import { adminConstants } from "../constant/admin-constant";
import { dataSync } from "../../services/data-sync";
import { alertActions } from "./alert-actions";

export const dataSyncActions = {
    getErrorsList,
    getErrorMessagesPaginated,
    markSyncErrorFixed,
    getErrorStates,
    getErrorStatesForBrand,

}

function getErrorsList(page, brand_id, from_date, to_date, filter, sort, pageSize) {
    return dispatch => { 
        dataSync.getErrorsListing(page, brand_id, from_date, to_date, filter, sort, pageSize).then(
            response => {
                dispatch(success(response))
            },
            error => {
                dispatch(failure(error))
            }
        )
    }
    function success(response) { return { type: adminConstants.GET_SYNC_ERRORS_LIST_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.GET_SYNC_ERRORS_LIST_FAILURE, payload: error } }
}

function getErrorStates() {
    return dispatch => { 
        dataSync.getErrorStates().then(
            response => {
                dispatch(success(response))
            },
            error => {
                dispatch(failure(error))
            }
        )
    }
    function success(response) { return { type: adminConstants.GET_ERROR_STATES_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.GET_ERROR_STATES_FAILURE, payload: error } }
}

function getErrorStatesForBrand(id) {
    return dispatch => { 
        dataSync.getErrorStatesForBrand(id).then(
            response => {
                dispatch(success(response))
            },
            error => {
                dispatch(failure(error))
            }
        )
    }
    function success(response) { return { type: adminConstants.GET_ERROR_STATES_FOR_BRAND_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.GET_ERROR_STATES_FOR_BRAND_FAILURE, payload: error } }
}

function getErrorMessagesPaginated(error_id, page, filter, sort, pageSize) {
    return dispatch => {
        return dataSync.getErrorMessagesPaginated(error_id, page, filter, sort, pageSize).then(
            response => {
                dispatch(success(response))
                return response;
            },
            error => {
                dispatch(failure(error))
            }
        )
    }
    function success(response) { return { type: adminConstants.GET_SYNC_ERRORS_MESSAGES_LIST_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.GET_SYNC_ERRORS_MESSAGES_LIST_FAILURE, payload: error } }
}


function markSyncErrorFixed(ids) {
    return dispatch => {
        dispatch(request());
        return dataSync.markSyncErrorFixed(ids).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
              
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.MARK_ERROR_FIXED_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.MARK_ERROR_FIXED_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.MARK_ERROR_FIXED_FAILURE,
            payload: error
        };
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/data-sync-actions.jsx